import React from 'react'

import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { MessageToAccountantForm } from '@components/forms/MessageToAccountantForm'
import { Fade, Typography } from '@components/ui'
import { SlideOver } from '@components/ui/SlideOver'

import successIllustrationSrc from '@assets/img/success_illustration.svg'

import { messages as formMessages } from '@components/forms/MessageToAccountantForm/messages'

const CrossFadeDiv = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  /* Lets the panel cap the height, so the form's body scrolls instead of the layer outgrowing it. */
  min-height: 0;
`

const FormLayerDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const SuccessWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 20px;

  img {
    margin-bottom: 8px;
  }
`

interface MessageToAccountantContentProps {
  onCancel: VoidFunction
}

function MessageToAccountantContent({ onCancel }: MessageToAccountantContentProps) {
  const [isMessageSent, setIsMessageSent] = React.useState(false)

  return (
    <CrossFadeDiv>
      <Fade in={!isMessageSent} unmountOnExit>
        <FormLayerDiv>
          <MessageToAccountantForm onCancel={onCancel} onSubmitSuccess={() => setIsMessageSent(true)} />
        </FormLayerDiv>
      </Fade>
      <Fade in={isMessageSent} unmountOnExit>
        <SuccessWrapper>
          <img src={successIllustrationSrc} alt="" width={187} height={192} />
          <Typography size="heading-3">
            <FormattedMessage id="messageToAccountant.success.title" defaultMessage="Üzenet elküldve!" />
          </Typography>
          <Typography size="400-md">
            <FormattedMessage
              id="messageToAccountant.success.description"
              defaultMessage="Hamarosan visszajelzünk az e-mail-címedre."
            />
          </Typography>
        </SuccessWrapper>
      </Fade>
    </CrossFadeDiv>
  )
}

interface MessageToAccountantSlideOverProps {
  onOpenChange: (open: boolean) => void
  open: boolean
}

/**
 * Lives at the app chrome level (mounted by SupportChannelRoot), so any component can open it and
 * no menu collapse can unmount it.
 */
export function MessageToAccountantSlideOver({ onOpenChange, open }: MessageToAccountantSlideOverProps) {
  const { formatMessage } = useIntl()

  return (
    <SlideOver title={formatMessage(formMessages.title)} open={open} onOpenChange={onOpenChange} skipBodyWrapper>
      <MessageToAccountantContent onCancel={() => onOpenChange(false)} />
    </SlideOver>
  )
}
